let expired = false;
let authenticated = false;
const listeners = new Set<() => void>();

export const isSessionExpired = () => expired;

export const setSessionAuthenticated = (value: boolean) => {
  authenticated = value;
};

export const markSessionExpired = () => {
  if (expired || !authenticated) return;
  expired = true;
  listeners.forEach(listener => listener());
};

export const clearSessionExpired = () => {
  expired = false;
};

export const onSessionExpired = (listener: () => void) => {
  listeners.add(listener);
  if (expired) listener();
  return () => {
    listeners.delete(listener);
  };
};
